var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 29,
    viewBox: "0 0 33 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8046 0H5.11528C2.70548 0 0.751953 1.97037 0.751953 4.40094V23.7651C0.751953 26.1956 2.70548 28.166 5.11528 28.166H27.8046C30.2144 28.166 32.1679 26.1956 32.1679 23.7651V4.40094C32.1679 1.97037 30.2144 0 27.8046 0Z",
    fill: "#1F2937"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1785 5.41699H8.74131C7.32036 5.41699 6.16846 6.62953 6.16846 8.12526C6.16846 9.621 7.32036 10.8335 8.74131 10.8335H24.1785C25.5994 10.8335 26.7513 9.621 26.7513 8.12526C26.7513 6.62953 25.5994 5.41699 24.1785 5.41699Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 26C20.0899 26 23 23.0899 23 19.5C23 15.9101 20.0899 13 16.5 13C12.9101 13 10 15.9101 10 19.5C10 23.0899 12.9101 26 16.5 26Z",
    fill: "#16A34A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9182 16.166V19.777L19.1681 21.5826",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.a750988cc7bc04b517d2a840902794e6.svg";
export { ForwardRef as ReactComponent };